import type { DailyForecast, MichiganTimezone } from '@miweather/shared';

export function ForecastPeriodCards({ daily, timezone }: { daily: DailyForecast[]; timezone: MichiganTimezone }) {
  if (!daily.length || !daily[0].detailedForecast) return null;

  const today = daily[0];
  const tomorrow = daily[1];

  const now = new Date();
  const currentHour = parseInt(now.toLocaleTimeString('en-US', { hour: 'numeric', hour12: false, timeZone: timezone }), 10);
  const isDaytime = currentHour >= 6 && currentHour < 18;

  const periods: { title: string; forecast: string; temp: string }[] = [];

  if (isDaytime) {
    if (today.detailedForecast) {
      periods.push({
        title: 'Today',
        forecast: today.detailedForecast,
        temp: `High ${Math.round(today.high)}°`,
      });
    }
    if (today.nightForecast) {
      periods.push({
        title: 'Tonight',
        forecast: today.nightForecast,
        temp: `Low ${Math.round(today.low)}°`,
      });
    }
  } else {
    if (today.nightForecast) {
      periods.push({
        title: 'Tonight',
        forecast: today.nightForecast,
        temp: `Low ${Math.round(today.low)}°`,
      });
    }
    if (tomorrow?.detailedForecast) {
      periods.push({
        title: 'Tomorrow',
        forecast: tomorrow.detailedForecast,
        temp: `High ${Math.round(tomorrow.high)}°`,
      });
    }
  }

  if (periods.length === 0) return null;

  return (
    <div>
      <h2 className="text-base font-bold mb-3">Forecast</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {periods.map((period, i) => (
          <div key={i} className="stat-box rounded-xl p-4">
            <div className="flex items-center justify-between mb-3">
              <span className="font-bold text-lg">{period.title}</span>
              <div className="flex items-baseline gap-1">
                <span className="text-xs text-white font-semibold uppercase tracking-wide">{period.temp.split(' ')[0]}</span>
                <span className="text-2xl font-black text-[#f97316]">{period.temp.split(' ')[1]}</span>
                <span className="text-2xl font-black text-[#f97316]">F</span>
              </div>
            </div>
            <p className="text-sm text-white/80 leading-relaxed">{period.forecast}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
